import {
  faAngleDown,
  faAngleUp,
  faTimes,
  faTrashAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormikDatePicker from "components/forms/formikFields/FormikDatePicker";
import { Field, FieldArray } from "formik";
import { useState } from "react";
import {
  Button,
  Col,
  Collapse,
  FormFeedback,
  InputGroup,
  Label,
  Row
} from "reactstrap";
import "./style.scss";
import drop_arrow from "assets/svgIcon/down-arrow-white-icon.svg";
import add_icon from "assets/images/add-icon.png";
import del_icon from "assets/images/del-red-icon.png";

const defaultSchedules = {
  startTime: "",
  endTime: "",
  mon: false,
  tue: false,
  wed: false,
  thu: false,
  fri: false,
  sat: false,
  sun: false,
};

const RenderFieldArray = (props) => {
  const { arrayHelpers } = props;
  const { name } = arrayHelpers;
  const { schedulesHospital } = arrayHelpers.form.values;
  if (schedulesHospital && schedulesHospital.length) {
    return schedulesHospital.map((schedule, indexKey) => {
      return (
        <div className="" key={indexKey}>
          <Row>
            <Col lg={5} className="pl-0 nexogic-date-fields">
              <Row>
                <Col>
                  <InputGroup>
                    <Field
                      id="rs_starttime"
                      name={`${name}[${indexKey}].startTime`}
                      type="text"
                      placeholder="Start Time"
                      component={FormikDatePicker}
                      inputprops={{
                        dateFormat: "h:mm aa",
                        showTimeSelect: true,
                        showTimeSelectOnly: true,
                        calendarClassName: "mycustomcal",
                        autoComplete: "off",
                        showTwoColumnMonthYearPicker: true,
                        timeIntervals: 30,
                      }}
                    />
                  </InputGroup>
                </Col>
                <Col>
                  <InputGroup>
                    <Field
                      id="rs_endtime"
                      name={`${name}[${indexKey}].endTime`}
                      type="text"
                      placeholder="End Time"
                      component={FormikDatePicker}
                      inputprops={{
                        dateFormat: "h:mm aa",
                        showTimeSelect: true,
                        showTimeSelectOnly: true,
                        autoComplete: "off",
                        calendarClassName: "mycustomcal",
                        timeIntervals: 30,
                      }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Col>
            <Col lg={6} className="nexogic-date-checkboxes-w">
              <div className="row nexogic-date-checkboxes">
                <div className="col">
                  <Field
                    className="nexogic-day-checkbox"
                    type="checkbox"
                    id={`${name}[${indexKey}].mon`}
                    name={`${name}[${indexKey}].mon`}
                  />
                  <Label htmlFor={`${name}[${indexKey}].mon`}></Label>
                  <Label>Mon</Label>
                </div>
                <div className="col">
                  <Field
                    className="nexogic-day-checkbox"
                    type="checkbox"
                    id={`${name}[${indexKey}].tue`}
                    name={`${name}[${indexKey}].tue`}
                  />
                  <Label htmlFor={`${name}[${indexKey}].tue`}></Label>
                  <Label>Tue</Label>
                </div>
                <div className="col">
                  <Field
                    className="nexogic-day-checkbox"
                    type="checkbox"
                    id={`${name}[${indexKey}].wed`}
                    name={`${name}[${indexKey}].wed`}
                  />
                  <Label htmlFor={`${name}[${indexKey}].wed`}></Label>
                  <Label>Wed</Label>
                </div>
                <div className="col">
                  <Field
                    className="nexogic-day-checkbox"
                    type="checkbox"
                    id={`${name}[${indexKey}].thu`}
                    name={`${name}[${indexKey}].thu`}
                  />
                  <Label htmlFor={`${name}[${indexKey}].thu`}></Label>
                  <Label>Thu</Label>
                </div>
                <div className="col">
                  <Field
                    className="nexogic-day-checkbox"
                    type="checkbox"
                    id={`${name}[${indexKey}].fri`}
                    name={`${name}[${indexKey}].fri`}
                  />
                  <Label htmlFor={`${name}[${indexKey}].fri`}></Label>
                  <Label>Fri</Label>
                </div>
                <div className="col">
                  <Field
                    className="nexogic-day-checkbox"
                    type="checkbox"
                    id={`${name}[${indexKey}].sat`}
                    name={`${name}[${indexKey}].sat`}
                  />
                  <Label htmlFor={`${name}[${indexKey}].sat`}></Label>
                  <Label>Sat</Label>
                </div>
                <div className="col">
                  <Field
                    className="nexogic-day-checkbox"
                    type="checkbox"
                    id={`${name}[${indexKey}].sun`}
                    name={`${name}[${indexKey}].sun`}
                  />
                  <Label htmlFor={`${name}[${indexKey}].sun`}></Label>
                  <Label>Sun</Label>
                </div>
              </div>
              {/* {!!props?.touched &&
                  !!props?.touched?.schedulesHospital &&
                  !!props?.errors &&
                  !!props?.errors?.schedulesHospital &&
                  typeof props.errors.schedulesHospital === "string" && (
                    <div className="d-inline">
                    <FormFeedback
                      className="d-flex"
                      invalid={!!props.errors.schedulesHospital}
                    >
                      {props.errors.schedulesHospital}
                    </FormFeedback>
                    </div>
                  )} */}
            </Col>
            <Col lg={1} className="pr-0 d-flex justify-content-end ml-0 col-auto">
            <Button
            id="rs_btn_del"
                      color="link"
                      className="nex-timeslot-del-btn del-btn rounded-circle"
                      onClick={() => arrayHelpers.remove(indexKey)}
                    >
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.2266" cy="16" r="15.75" fill="#FFEAEF" />
                        <path d="M11.3984 13.7734L12.2586 20.1323C12.426 21.3702 12.5097 21.9892 12.9337 22.3597C13.3577 22.7302 13.9823 22.7302 15.2315 22.7302H18.4692C19.7184 22.7302 20.343 22.7302 20.767 22.3597C21.191 21.9892 21.2747 21.3702 21.4421 20.1323L22.3023 13.7734" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M14.5156 11.0475V11.0475C14.5156 10.2672 14.5156 9.87708 14.6572 9.57473C14.8061 9.25693 15.0616 9.00138 15.3794 8.85254C15.6818 8.71094 16.0719 8.71094 16.8522 8.71094V8.71094C17.6324 8.71094 18.0226 8.71094 18.3249 8.85254C18.6427 9.00138 18.8983 9.25693 19.0471 9.57473C19.1887 9.87708 19.1887 10.2672 19.1887 11.0475V11.0475" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M22.3023 11.0547L11.3984 11.0547" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M14.8906 14.1719L15.28 20.0132" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.7957 14.1719L18.4062 20.0132" stroke="#FF9191" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </Button>

              {/* <Button
                id="rs_btn_del"
                color="danger"
                className="nex-"
                onClick={() => arrayHelpers.remove(indexKey)}
              > */}
                {/* <div className="nex-del"> */}
                    {/* <svg width={12} height={16} viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }}>
                      <path d="M1 5.17969L1.53146 9.10872C1.75473 10.7593 1.86636 11.5846 2.43166 12.0786C2.99696 12.5725 3.83131 12.5725 5.5 12.5725V12.5725C7.16869 12.5725 8.00303 12.5725 8.56833 12.0786C9.13363 11.5846 9.24527 10.7593 9.46853 9.10872L9.99999 5.17969" stroke="#FF9191" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3.57031 2.92857V2.92857C3.57031 1.86345 4.43376 1 5.49888 1V1C6.564 1 7.42745 1.86345 7.42745 2.92857V2.92857" stroke="#FF9191" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M10 2.92969L1 2.92969" stroke="#FF9191" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3.89062 5.5L4.21205 10.3214" stroke="#FF9191" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M7.11049 5.5L6.78906 10.3214" stroke="#FF9191" strokeLinecap="round" strokeLinejoin="round" />
                    </svg> */}
                  {/* </div> */}
                {/*<FontAwesomeIcon
                  icon={faTrashAlt}
                  className="text-danger"
                  style={{ marginTop: "5px", fontSize: "15px" }}
                />*/}
                {/* <img src={del_icon} alt="" /> */}
              {/* </Button> */}
            </Col>
          </Row>
          {indexKey === schedulesHospital.length - 1 && (
            <Row>
              <Col className="pl-0">
                <Button
                  id="rs_btn_add"
                  color="primary"
                  className="nex-btn-primary small nexogic-hospita-add-btn"
                  outline
                  onClick={() =>
                    arrayHelpers.insert(indexKey + 1, defaultSchedules)
                  }
                >
                  {/* <img src={add_icon} alt="" /> */}
                  {" Add"}
                </Button>
              </Col>
            </Row>
          )}
        </div>
      );
    });
  }
  return (
    <Row>
      <Col className="mt-2">
        <Button
          id="rs_btn_add_2"
          color="link"
          className="nex-btn-primary-outline small nexogic-hospita-add-btn"
          onClick={() => arrayHelpers.push({ ...defaultSchedules })}
        >
          <img src={add_icon} alt="" />{"Add"}
        </Button>
      </Col>
    </Row>
  );
};

export const RenderSchedules = (props) => {
  const { values } = props;
  const { schedulesHospital } = values;
  const [openOfficeTimings, setOfficeTimingsOpen] = useState(true);
  const toggleOfficeTimings = () => setOfficeTimingsOpen(!openOfficeTimings);

  return (
    <Col lg="12">
      <Row className="nexogic-form-inner-card card nexogic-hospital-inner-card">
        <Col
          className={`p-0 ${
            !!props?.touched &&
            !!props?.touched?.schedulesHospital &&
            !!props?.errors &&
            !!props?.errors?.schedulesHospital &&
            typeof props.errors.schedulesHospital === "string"
              ? ``
              : ``
          }`}
        >
          <h5 className="card-title">
            Work days and hours
            <img src={drop_arrow} alt="" />
            {/** <FontAwesomeIcon
              icon={openOfficeTimings ? faAngleUp : faAngleDown}
              onClick={toggleOfficeTimings}
              className="fa-fw text-dark"
            />*/}
          </h5>
          {!!props?.touched &&
            !!props?.touched?.schedulesHospital &&
            !!props?.errors &&
            !!props?.errors?.schedulesHospital &&
            typeof props.errors.schedulesHospital === "string" && (
              <FormFeedback
                className="d-flex"
                invalid={!!props.errors.schedulesHospital}
              >
                {props.errors.schedulesHospital}
              </FormFeedback>
            )}
        </Col>
        {/** 
        <Col xs={12} md={6} className="pl-0">
          {schedulesHospital.length > 0 && (
            <Row>
              <Col className="d-none d-md-block">
                <div className="d-flex text-center">
                  <div className="flex-grow-1 mx-1">
                    <Label>Mon</Label>
                  </div>
                  <div className="flex-grow-1 mx-1">
                    <Label>Tue</Label>
                  </div>
                  <div className="flex-grow-1 mx-1">
                    <Label>Wed</Label>
                  </div>
                  <div className="flex-grow-1 mx-1">
                    <Label>Thu</Label>
                  </div>
                  <div className="flex-grow-1 mx-1">
                    <Label>Fri</Label>
                  </div>
                  <div className="flex-grow-1 mx-1">
                    <Label>Sat</Label>
                  </div>
                  <div className="flex-grow-1 mx-1">
                    <Label>Sun</Label>
                  </div>
                </div>
              </Col>
              <Col xs="auto" className="px-1 d-none d-md-block">
                <Button color="link">
                  <FontAwesomeIcon
                    icon={faTimes}
                    className="fa-fw text-white"
                  />
                </Button>
              </Col>
            </Row>
          )}
        </Col>
        */}
        <Collapse isOpen={openOfficeTimings}>
        <FieldArray
          name={`schedulesHospital`}
          render={(arrayHelpers) => (
            <RenderFieldArray arrayHelpers={arrayHelpers} {...props} />
          )}
        />
      </Collapse>
      </Row>
      
    </Col>
  );
};
